import React, {useState, useEffect} from 'react'
import {history, pages} from "../../configureHistory";
import i18n from "i18next";
import Api from "../Api/Api";

class FirstPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            code: this.props.match.params.code,
            domainId: this.props.match.params.domainId,
            preview: this.props.match.params.domainId!==undefined,
            pageType: this.props.match.params.pageType,
            storeId: this.props.match.params.storeId
        };
        window.history.replaceState(null, '', `/${this.state.code}`)
    }

    redirectToPage():void {
        if (this.state.code.length === 5 || this.state.code.length === 6) {
          history.push({
            pathname: '/register',
            state: {code: this.state.code}
          });
        } else if (this.state.code.length === 3 && this.state.preview) {
          history.push({
              pathname: '/register',
              state: {...this.state}
          });
        }
    }

    componentWillUnmount() {
        i18n.off('languageChanged', this.props.languageChanged);
    }

    componentDidMount(): void {
        let {code, domainId, preview} = this.state;
        //Refresh
        if(this.props.history.location.state !== undefined){
            code = this.props.history.location.state.code;
        }
        if(this.props.history.location.state!==undefined && this.props.history.location.state.order !==undefined){
            code = this.props.history.location.state.order.LinkCode;
        }
        if (pages.includes(code)) {
            code = history.location.pathname.replace('/','');
        }
        //Set local storage
        // @ts-ignore
        sessionStorage.setItem('reqID', code);
        if (!this.state.preview && code !== undefined) {
            this.props.callGetOrder(code).then((res: any) => {
                    if (res.error) {
                        this.props.showPreloader(false);
                        //this.props.styles.CommonSettings = null;
                        //this.props.styles.CommonSettings.DefaultLanguage = null;
                        // this.props.styles.CommonSettings.SecondaryLanguage = "";
                        history.push({pathname:'/notFound'});
                        return;
                    }
                    this.props.callGetStyles(res.data['DomainId'],res.data['StoreId'], false);
                    Api.getTranslations(res.data['DomainId'], false, code).then(data => data.json()).then(
                        res => {
                            this.setState({data: res});
                            this.setState({code});
                            i18n
                                .init({
                                    resources: res
                                });
                        }
                    ).finally(() => {
                        i18n.on('languageChanged', this.props.languageChanged);
                        this.props.showPreloader(false);
                        this.redirectToPage();
                    });
                }).catch((er: any) => {
                  console.log(er.message)
                })
                
        } else if(this.state.preview) {
            //TODO improve timeout. Move to backend after successful save in database
            //Preview
            setTimeout(() => {
                this.props.callGetStyles(domainId, null, true);
                Api.getTranslations(domainId, true,code).then(data => data.json()).then(
                    res => {
                        this.setState({data: res});
                        i18n
                            .init({
                                resources: res
                            });
                    }
                ).finally(()=>{
                    i18n.on('languageChanged', this.props.languageChanged);
                    this.props.showPreloader(false);
                    this.redirectToPage();
                });
            }, 2000);
        }
        if (!this.state.preview && code === undefined){
            this.props.showPreloader(false);
        }
    }

    render() {
        return (
            <div>
            </div>
        )
    }
}
export default FirstPage;
